<script>
  import { t } from '../i18n/index.js';
  import InfoHint from './InfoHint.svelte';
  import { NATURA_CODES, requiresNatura } from '../lib/natura.js';

  // Natura IVA selector. By law a 0%-VAT line must declare a "Natura"; this
  // component only shows when vatRate is 0 so it never clutters ordinary lines.
  export let value = '';
  export let vatRate = 0;
  export let required = true;

  $: show = requiresNatura(vatRate);
  // Flag the gap while the operator is still on the form, rather than letting
  // them discover it from an SdI scarto days later.
  $: incomplete = show && required && !value;
</script>

{#if show}
  <!-- The select is nested in the label so several of these can coexist on one
       form (one per zero-rated line) without colliding on an id. -->
  <label class="block">
    <span class="label flex items-center gap-1">
      {$t('naturaIva.label')}{#if required}&nbsp;*{/if}
      <InfoHint term="naturaIva" />
    </span>
    <select
      class="input"
      class:border-red-500={incomplete}
      aria-invalid={incomplete}
      bind:value
    >
      <option value="">{$t('naturaIva.placeholder')}</option>
      {#each NATURA_CODES as code}
        <option value={code}>{$t(`naturaIva.options.${code}`)}</option>
      {/each}
    </select>
    <span
      class="block mt-1 text-xs"
      class:text-danger={incomplete}
      class:text-muted={!incomplete}
    >
      {incomplete ? $t('naturaIva.required') : $t('naturaIva.hint')}
    </span>
  </label>
{/if}
